module.exports = __webpack_public_path__ + "resources/img/img_alyac3.87f9cc8c6e48caa0535f83dba6e6b663.png";